export default __webpack_public_path__ + "static/kaeltetrockner-fuer-trockene-druckluft-46b06ece8cb2a8131cf400f7136099b1.png";